import { IOnInit } from "angular";
import { ColDef } from "../../../../../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../../../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../../../../../records/server/query";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../../../records/server/serverUtility";
import { MachineConfiguration } from "../../../../../models/machineConfiguration";
import { ProgressiveDefinition } from "../../../../../models/progressiveDefinition";

const gridId = Symbol("main.machines.progressives.detail.machines.edit");

export class ProgressivesDetailMachinesEditComponentController
  implements IOnInit
{
  static $inject = [
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    ServerUtilityName,
  ];

  /* bindings */
  readonly progressiveDefinition!: ProgressiveDefinition;
  readonly progressiveMachineConfigurations!: MachineConfiguration[];
  initialSelectedIds: number[] = [];
  /* end bindings */

  readonly additionalColumns: ColDef[];
  gridSettings: IGridSettings;
  readonly defaultQuery: IQuery = {
    CurrentConfiguration: true,
  };

  progressiveConfigurationsOnly: boolean = true;

  constructor(
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly serverUtility: ServerUtility
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    this.additionalColumns = [columnDefinitionService.getSelectColDef()];
  }
  $onInit(): void {
    this.initialSelectedIds = this.progressiveMachineConfigurations.map(
      (mc) => mc.Id
    );
    this.progressiveConfigurationsOnlyChanged(
      this.progressiveConfigurationsOnly
    );
  }

  progressiveConfigurationsOnlyChanged(progressiveConfigurationsOnly: boolean) {
    this.defaultQuery.ProgressiveDefinitionId = progressiveConfigurationsOnly
      ? this.progressiveDefinition.Id
      : undefined;
  }

  currentConfigurationChanged(currentConfigurationsOnly: boolean) {
    if (!currentConfigurationsOnly) {
      this.defaultQuery.CurrentConfiguration = undefined;
    }
  }

  gridSelectionChanged(args: {
    data: MachineConfiguration;
    selected: boolean;
    gridSelection: MachineConfiguration[];
  }) {
    const machineConfigurationId = args.data.Id;
    const progressiveDefinitionId = args.selected
      ? this.progressiveDefinition.Id
      : undefined;
    this.serverUtility.sendApiRequest({
      method: "PUT",
      url: `/api/machines/MachineConfiguration/${machineConfigurationId}/ProgressiveDefinitionId`,
      data: {
        ProgressiveDefinitionId: progressiveDefinitionId,
      },
    });
  }
}
